export const tableViewButtonSx = {
  minWidth: 92,
  height: 38,
  borderRadius: '10px',
  bgcolor: '#DFE5F6',
  color: '#294190',
  textTransform: 'none',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  '&:hover': {
    bgcolor: '#DFE5F6',
  },
  '& .material-symbols-rounded': {
    fontSize: 18,
  },
};

export const tableDeleteButtonSx = {
  minWidth: 92,
  height: 38,
  borderRadius: '10px',
  bgcolor: '#FDE0DC',
  color: '#DA342E',
  textTransform: 'none',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  '&:hover': {
    bgcolor: '#FDE0DC',
  },
  '& .material-symbols-rounded': {
    fontSize: 18,
  },
};

export const tableApproveButtonSx = {
  minWidth: 92,
  height: 38,
  borderRadius: '10px',
  bgcolor: '#E6F4D7',
  color: '#4F8506',
  textTransform: 'none',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  '&:hover': {
    bgcolor: '#E6F4D7',
  },
  '&.Mui-disabled': {
    bgcolor: '#EEF5E5',
    color: '#9CB67B',
  },
  '& .material-symbols-rounded': {
    fontSize: 18,
  },
};

export const tableRejectButtonSx = {
  minWidth: 92,
  height: 38,
  borderRadius: '10px',
  bgcolor: '#FDE0DC',
  color: '#DA342E',
  textTransform: 'none',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  '&:hover': {
    bgcolor: '#FDE0DC',
  },
  '&.Mui-disabled': {
    bgcolor: '#FDEDEC',
    color: '#E39D99',
  },
  '& .material-symbols-rounded': {
    fontSize: 18,
  },
};

export const tableDeactivateButtonSx = {
  minWidth: 92,
  height: 38,
  borderRadius: '10px',
  bgcolor: '#F1F1F1',
  color: '#6C6A86',
  textTransform: 'none',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  '&:hover': {
    bgcolor: '#F1F1F1',
  },
  '&.Mui-disabled': {
    bgcolor: '#F5F5F5',
    color: '#B0B0B0',
  },
  '& .material-symbols-rounded': {
    fontSize: 18,
  },
};

export const compactTableActionButtonSx = {
  minWidth: 0,
  height: 30,
  px: 1,
  borderRadius: '8px',
  textTransform: 'none',
  fontSize: 13,
  lineHeight: '18px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  '& .MuiButton-startIcon': {
    marginRight: '4px',
    marginLeft: 0,
  },
  '&:hover': {
    opacity: 1,
  },
};
